import * as React from 'react';
import { SVGProps } from 'react';
import { Box, SimplePaletteColorOptions } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Logo = (props: SVGProps<SVGSVGElement>) => {
    const theme = useTheme();
    const primary = theme?.palette?.primary as SimplePaletteColorOptions;
    const secondary = theme?.palette?.secondary as SimplePaletteColorOptions;
    const logoSize = {
        x: 140,
        y: 50,
    };
    const themeTweaks: Record<string, any> =
        theme.palette.mode === 'dark'
            ? {
                  layer1Color: '#dddddd',
                  layer2Color: primary.light,
                  shadowOpacity: 0.3,
              }
            : {
                  layer1Color: primary.main,
                  layer2Color: secondary.main,
                  shadowOpacity: 0.3,
              };

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flex: '0 0 auto',
                alignSelf: 'stretch',
                margin: '0 .5rem 0 .5rem',
                aspectRatio: `${logoSize.x} / ${logoSize.y}`,
                '& > svg': {
                    flex: '1 1 100%',
                    height: '100%',
                    width: 'auto',
                },
            }}
        >
            <svg
                version="1.1"
                viewBox={`0 0 ${logoSize.x} ${logoSize.y}`}
                width={logoSize.x}
                height={logoSize.y}
                preserveAspectRatio="xMin yMin meet"
            >
                <g
                    aria-label="Admin"
                    fill={themeTweaks.layer1Color}
                >
                    <path d="M0 45.26L13.75 9.47L18.85 9.47L33.50 45.26L28.10 45.26L23.93 34.42L8.96 34.42L5.03 45.26L0 45.26M10.33 30.57L22.46 30.57L18.73 20.65Q17.02 16.14 16.19 13.23Q15.50 16.67 14.26 20.07L10.33 30.57ZM53.54 45.26L53.54 41.99Q51.07 45.85 46.29 45.85Q43.19 45.85 40.59 44.14Q37.99 42.43 36.56 39.37Q35.13 36.30 35.13 32.32Q35.13 28.44 36.43 25.28Q37.72 22.12 40.31 20.43Q42.90 18.75 46.09 18.75Q48.44 18.75 50.27 19.74Q52.10 20.73 53.25 22.31L53.25 9.47L57.62 9.47L57.62 45.26L53.54 45.26M39.65 32.32Q39.65 37.30 41.75 39.77Q43.85 42.24 46.70 42.24Q49.58 42.24 51.60 39.88Q53.61 37.52 53.61 32.69Q53.61 27.37 51.56 24.88Q49.51 22.39 46.51 22.39Q43.58 22.39 41.61 24.78Q39.65 27.17 39.65 32.32ZM64.53 45.26L64.53 19.34L68.46 19.34L68.46 22.97Q69.68 21.07 71.70 19.91Q73.73 18.75 76.32 18.75Q79.20 18.75 81.04 19.95Q82.89 21.14 83.64 23.29Q86.72 18.75 91.65 18.75Q95.51 18.75 97.58 20.89Q99.66 23.02 99.66 27.47L99.66 45.26L95.29 45.26L95.29 28.93Q95.29 26.29 94.86 25.13Q94.43 23.97 93.31 23.27Q92.19 22.56 90.67 22.56Q87.94 22.56 86.13 24.38Q84.33 26.20 84.33 30.20L84.33 45.26L79.93 45.26L79.93 28.42Q79.93 25.49 78.86 24.02Q77.78 22.56 75.34 22.56Q73.49 22.56 71.91 23.54Q70.34 24.51 69.63 26.39Q68.92 28.27 68.92 31.81L68.92 45.26L64.53 45.26ZM106.20 14.53L106.20 9.47L110.60 9.47L110.60 14.53L106.20 14.53M106.20 45.26L106.20 19.34L110.60 19.34L110.60 45.26L106.20 45.26ZM117.29 45.26L117.29 19.34L121.24 19.34L121.24 23.02Q124.10 18.75 129.49 18.75Q131.84 18.75 133.80 19.59Q135.77 20.43 136.74 21.80Q137.72 23.17 138.11 25.05Q138.35 26.27 138.35 29.32L138.35 45.26L133.96 45.26L133.96 29.49Q133.96 26.81 133.45 25.48Q132.93 24.15 131.63 23.35Q130.32 22.56 128.56 22.56Q125.76 22.56 123.72 24.34Q121.68 26.12 121.68 31.10L121.68 45.26L117.29 45.26Z" />
                </g>
                {/* <g fill={themeTweaks.layer1Color}>
                    <path
                        d="M19.1,15c-0.2-1.5-1.1-3.6-3-4.5c-2.5-1.2-4.7-0.9-5.2-0.9c-0.5,0-6.8,0-6.8,0v19.8h4.3v-5.6c0,0,1.8,0,3.3,0
		s2.8-0.2,3.6-0.6s2.5-1.3,3.3-3C19.2,19.3,19.3,16.5,19.1,15z M14.4,19.1c-0.2,0.3-1.1,1-2.4,1s-3.5,0-3.5,0v-6.7
		c0,0,3.1,0,3.8,0.1c0.8,0.1,2.6,0.5,2.8,2.4C15.1,17.8,14.6,18.7,14.4,19.1z"
                    />
                    <polygon points="57.6,9.6 57.6,13.5 63.1,13.5 63.1,29.5 67.4,29.5 67.4,13.4 72.9,13.4 72.9,9.6 	" />
                    <polygon
                        points="74.3,9.6 88.2,9.6 88.2,13.6 78.6,13.6 78.6,17.7 87.2,17.7 87.2,21.4 78.6,21.4 78.6,25.6 88.5,25.6
		88.5,29.5 74.3,29.5 	"
                    />
                    <polygon
                        points="261.4,9 275.3,9 275.3,13 265.7,13 265.7,17.1 274.3,17.1 274.3,20.9 265.7,20.9 265.7,25 275.6,25
		275.6,28.9 261.4,28.9 	"
                    />
                    <polygon points="207.2,9 207.2,28.8 219.3,28.8 219.3,24.9 211.5,24.9 211.5,8.9 	" />
                    <path d="M196,9h-4.2l-8.2,19.9h4.4l1.8-4.2h8.1l1.8,4.2h4.6L196,9z M191.6,20.7l2.3-5.8l2.3,5.8H191.6z" />
                    <path
                        d="M182.7,18.8h-4.4V24c0,0-0.7,1.1-4.2,1.1s-5-3.5-5-6.8s2.8-5.7,5.5-5.7s3.7,0.8,4.2,1.3
		c0.4-0.4,2.8-2.9,2.8-2.9s-2.4-2.6-6.9-2.6s-5.9,1.8-7.7,3.5s-3.4,6.5-1.8,10.6s4.7,5.8,8.1,6.4c3.4,0.6,5.7-0.4,7-1.3
		c1.3-0.9,2.3-2,2.3-2L182.7,18.8z"
                    />
                    <path
                        d="M113.5,23.3l-2.9,3c0,0,2.7,2.6,6.2,3.1c3.4,0.6,6.4-0.2,7.8-1.9c1.4-1.7,2.4-5,0.1-7.6s-6.5-2.5-7.9-3.4
		c-1.4-1-1.2-3.4,1.3-3.4s4.7,1.5,4.7,1.5l2.8-2.8c0,0-3.2-3-8.5-2.5s-5.7,4.4-5.7,5.4s-0.1,4.3,2.9,5.4s7.2,1.8,7.2,3.5
		S119.5,27.8,113.5,23.3z"
                    />
                    <path
                        d="M44.7,23.3l-2.9,3c0,0,2.7,2.6,6.2,3.1s6.4-0.2,7.8-1.9c1.4-1.7,2.4-5,0.1-7.6s-6.5-2.5-7.9-3.4
		c-1.4-1-1.2-3.4,1.3-3.4s4.7,1.5,4.7,1.5l2.8-2.8c0,0-3.2-3-8.5-2.5s-5.7,4.4-5.7,5.4s-0.1,4.3,2.9,5.4s7.2,1.8,7.2,3.5
		C52.6,25.3,50.7,27.8,44.7,23.3z"
                    />
                    <path
                        d="M108.4,29.5l-5-7.1c0.2-0.1,0.3-0.2,0.5-0.3c2.5-1.4,2.6-3.1,2.9-4.1c0.4-1,0.4-4.9-1.3-6.4s-3.4-2-6.2-2
		s-8.1,0-8.1,0v19.9h4.3v-6.3h3l4.3,6.3L108.4,29.5z M99.6,19.3c-1.2,0-3.9,0-3.9,0v-5.9c0,0,2.3,0,3.9,0c1.6,0,3.1,0.3,3.1,2.8
		C102.6,18.4,101,19.3,99.6,19.3z"
                    />
                    <path
                        d="M259,28.9l-5-7.1c0.1-0.1,0.3-0.2,0.5-0.3c2.5-1.4,2.6-3.1,2.9-4.1c0.4-1,0.4-4.9-1.3-6.4
		c-1.6-1.5-3.4-2-6.2-2S242,9,242,9v19.9h4.3v-6.3h3l4.3,6.3L259,28.9z M250.2,18.7c-1.2,0-3.9,0-3.9,0v-5.9c0,0,2.3,0,3.9,0
		c1.6,0,3.1,0.3,3.1,2.9C253.2,17.8,251.6,18.7,250.2,18.7z"
                    />
                    <path
                        d="M39.6,14.7c-1.2-2.3-4.1-5.3-9.4-5.3c0,0-1.2,0-3.2,0.5s-3.6,2.1-5,3.7c-1.4,1.6-2,4-2,6.6c0,2.6,0.9,4.5,2,6
		c1.1,1.6,2.8,2.8,4.9,3.5c2.1,0.8,5.4,0.7,7.5-0.2c2.1-0.9,3.6-1.3,5.4-5C41.6,20.7,40.8,16.9,39.6,14.7z M30.5,26.3
		c-1.1,0-5.9-0.5-5.9-7c0-4.8,4.6-6,5.9-6s5.8,1.5,5.8,6.8S31.6,26.3,30.5,26.3z"
                    />
                    <path
                        d="M239,14.1c-1.1-2.3-4.1-5.3-9.4-5.3c0,0-1.2,0-3.2,0.5s-3.6,2.1-5,3.7c-1.4,1.6-2,4-1.9,6.6
		c0,2.6,0.9,4.5,2.1,6c1.1,1.6,2.8,2.8,4.9,3.5c2.1,0.8,5.4,0.7,7.5-0.2c2.1-0.9,3.6-1.3,5.4-5C241,20.1,240.1,16.3,239,14.1z
		 M229.8,25.7c-1.1,0-5.9-0.5-5.9-7c0-4.8,4.6-6,5.9-6s5.8,1.5,5.8,6.8S230.9,25.7,229.8,25.7z"
                    />
                </g>
                <g fill={themeTweaks.layer2Color}>
                    <path
                        d="M16.8,22.5c-1.2,1-2.7,1.3-4.9,1.4v-3.8c1-0.1,1.8-0.6,2.2-1.1c0.5-0.6,0.6-1.5,0.6-2.6s-0.3-2-1-2.4
		c-0.5-0.2-1.1-0.4-1.8-0.5l0-4c2.3,0.1,4.1,0.7,5.2,1.8c1.4,1.2,2.1,2.2,2.1,6C19.3,20.1,18.5,21.1,16.8,22.5z"
                    />
                    <path d="M72.9,13.4l-4.8,0V9.6l4.8,0V13.4z" />
                    <path d="M83.3,21.4v-3.8l3.8,0v3.8L83.3,21.4z M88.5,29.5l-5.2,0v-3.9l5.2,0V29.5z M83.3,13.5V9.6h4.9v3.9H83.3z" />
                    <path
                        d="M182.7,18.8v7c-1.9,2.2-3.8,3.5-8.2,3.5c-2.8,0-5.1-1.3-7-3.1l3-3c0,0,0.1,0.1,0.1,0.1
		c1.1,1.1,2.4,1.7,3.9,1.7s2.7-0.3,3.7-0.9l0.1-5.3L182.7,18.8z M181.7,11.1l-2.8,2.9c-0.6-0.5-2.1-1.4-4.4-1.4c0,0,0-4.1,0-4.1
		C177.2,8.6,179.7,9.2,181.7,11.1z"
                    />
                    <path d="M204.4,28.9h-4.6l-1.8-4.2h-8.1l1.8-3.9h4.7l-2.4-5.6L196,9L204.4,28.9z" />
                    <path d="M219.3,28.8h-12l4.3-4.2v0.3l7.8,0V28.8z" />
                    <path
                        d="M118.8,25.7l0,3.9c-3.1,0-5.9-1.2-8.3-3.5l2.9-2.9C115.5,24.7,117.1,25.7,118.8,25.7z M125.6,11.7l-2.8,2.8
		c-0.8-0.5-1.8-0.9-2.6-1.2l0-4.1c0.6,0.1,1.2,0.2,1.9,0.4C123.4,10.2,124.5,10.8,125.6,11.7z"
                    />
                    <path
                        d="M50,25.7l0,3.9c-3,0-5.8-1.3-8.3-3.6l2.9-2.9C46.6,24.7,48.3,25.7,50,25.7z M56.8,11.7L54,14.6
		c-1.4-0.8-1.8-0.9-2.6-1.2l0-4.1C54.2,9.8,55.8,10.9,56.8,11.7z"
                    />
                    <path
                        d="M239,14.1c-1.1-2.2-3.9-5.1-8.8-5.3v3.9c1.6,0.2,5.5,1.8,5.5,6.8c0,4.9-4,6-5.5,6.1v3.9c1.3,0,2.7-0.3,3.7-0.7
		c2.1-0.9,3.6-1.3,5.4-5C241,20.1,240.1,16.4,239,14.1z"
                    />
                    <path
                        d="M259,28.9l-5.5,0l-4.3-6.3l0,0h-1.9v-3.9h2.5c0,0,0.5,0,0.9-0.1c0.1,0,1-0.2,1.6-0.8c0.4-0.4,0.7-1.1,0.8-1.6
		c0,0,3.2,0,4.6,0c-0.1,2.9-1.4,4.7-3.7,5.6l0.5,0.8L259,28.9z"
                    />
                    <path
                        d="M108.4,29.5l-5.5,0l-4.3-6.3l0,0h-1.9v-3.9h2.5c0,0,0.5,0,0.9-0.1c0.1,0,1-0.2,1.6-0.8
		c0.3-0.4,0.8-1.1,0.9-1.6c0,0,3.1,0,4.5,0c-0.1,2.9-1.3,4.8-3.6,5.7L108.4,29.5z"
                    />
                    <path
                        d="M39.6,14.7c-1.1-2.2-3.9-5.1-8.8-5.3v3.9c1.6,0.2,5.5,1.8,5.5,6.8c0,4.9-4,6-5.5,6.1v3.9
		c1.3,0,2.7-0.3,3.7-0.7c2.1-0.9,3.6-1.3,5.4-5C41.6,20.7,40.8,16.9,39.6,14.7z"
                    />
                    <path d="M270.4,20.8v-3.8h3.9v3.8H270.4z M275.6,28.9h-5.3V25h5.3V28.9z M270.4,13V9h5V13H270.4z" />
                </g>
                <g>
                    <g fill={themeTweaks.layer2Color}>
                        <polygon points="159.1,15.7 159.1,3.4 156.9,3.4" />
                        <polygon points="133,18 133,34.1 135.8,34.1" />
                        <polygon points="149,34.1 159.1,34.1 159.1,32.3" />
                        <polygon points="146.3,3.4 133,3.4 133,5.7" />
                        <polygon
                            opacity={themeTweaks.shadowOpacity}
                            points="154.4,13.5 138.5,26.5 139.5,31.8 157.1,28.6"
                        />
                    </g>
                    <g fill={themeTweaks.layer1Color}>
                        <path d="M130.9,6.1l5.3,30.2l25.7-4.5l-5.3-30.2L130.9,6.1z M138.8,32.7l-4.3-24.1l19.3-3.4l4.3,24.1" />
                    </g>
                </g> */}
            </svg>
        </Box>
    );
};

export default Logo;
